const AVAILABLE_IMAGE_MIME_TYPES = [
  'image/apng',
  'image/bmp',
  'image/gif',
  'image/x-icon',
  'image/jpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
];

// TODO #MYRE-3366: move into engine
export function getTypeFromExtension(extension: string): 'pdf' | 'img' {
  return getTypeFromMime(getMimeType(extension));
}

function getMimeType(extension: string): string {
  switch (extension.toLowerCase()) {
    case 'pdf': {
      return 'application/pdf';
    }
    case 'jpg': {
      return 'image/jpeg';
    }
    case 'svg': {
      return 'image/svg+xml';
    }
    case 'tif': {
      return 'image/tiff';
    }
    case 'ico': {
      return 'image/x-icon';
    }
    default: {
      return `image/${extension}`;
    }
  }
}

function getTypeFromMime(mime: string): 'img' | 'pdf' {
  if (mime === 'application/pdf') {
    return 'pdf';
  }

  if (AVAILABLE_IMAGE_MIME_TYPES.includes(mime)) {
    return 'img';
  }
}
